"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));
var _colors = _interopRequireDefault(require("@argo/principles/colors"));
var _typography = _interopRequireDefault(require("@argo/principles/typography"));
var React = _interopRequireWildcard(require("react"));
var primary = _colors["default"].primary;
var StyledParagraph = (0, _styledBase["default"])('p', {
  target: "e12faeex0",
  label: "StyledParagraph"
})(function (props) {
  return _typography["default"].types[props.type];
}, " color:", function (props) {
  return props.inverse ? primary.white : primary.charcoal;
}, ";text-align:", function (props) {
  return props.textAlign ? props.textAlign : 'left';
}, ";", function (props) {
  return props.defaultMargin ? '' : 'margin: 0;';
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9QYXJhZ3JhcGgvaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT21DIiwiZmlsZSI6Ii4uLy4uL3NyYy9QYXJhZ3JhcGgvaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgY29sb3JzIGZyb20gJ0BhcmdvL3ByaW5jaXBsZXMvY29sb3JzJztcbmltcG9ydCB0eXBvZ3JhcGh5IGZyb20gJ0BhcmdvL3ByaW5jaXBsZXMvdHlwb2dyYXBoeSc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgKiBhcyBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IHsgcHJpbWFyeSB9ID0gY29sb3JzO1xuXG5jb25zdCBTdHlsZWRQYXJhZ3JhcGggPSBzdHlsZWQoJ3AnKWBcbiAgJHtwcm9wcyA9PiB0eXBvZ3JhcGh5LnR5cGVzW3Byb3BzLnR5cGVdfVxuXG4gIGNvbG9yOiAke3Byb3BzID0+IChwcm9wcy5pbnZlcnNlID8gcHJpbWFyeS53aGl0ZSA6IHByaW1hcnkuY2hhcmNvYWwpfTtcbiAgdGV4dC1hbGlnbjogJHtwcm9wcyA9PiAocHJvcHMudGV4dEFsaWduID8gcHJvcHMudGV4dEFsaWduIDogJ2xlZnQnKX07XG4gICR7cHJvcHMgPT4gKHByb3BzLmRlZmF1bHRNYXJnaW4gPyAnJyA6ICdtYXJnaW46IDA7Jyl9XG5gO1xuXG5jb25zdCBQYXJhZ3JhcGggPSBwcm9wcyA9PiA8U3R5bGVkUGFyYWdyYXBoIHsuLi5wcm9wc30gLz47XG5cblBhcmFncmFwaC5kaXNwbGF5TmFtZSA9ICdQYXJhZ3JhcGgnO1xuXG5QYXJhZ3JhcGguZGVmYXVsdFByb3BzID0ge1xuICBpbnZlcnNlOiBmYWxzZSxcbiAgdHlwZTogJ2JvZHknLFxuICB0ZXh0QWxpZ246ICdsZWZ0JyxcbiAgZGVmYXVsdE1hcmdpbjogZmFsc2UsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBQYXJhZ3JhcGg7XG4iXX0= */");
var Paragraph = function Paragraph(props) {
  return React.createElement(StyledParagraph, props);
};
Paragraph.displayName = 'Paragraph';
Paragraph.defaultProps = {
  inverse: false,
  type: 'body',
  textAlign: 'left',
  defaultMargin: false
};
var _default = Paragraph;
exports["default"] = _default;
Paragraph.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Paragraph",
  "props": {
    "inverse": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "'body'",
        "computed": false
      },
      "required": false
    },
    "textAlign": {
      "defaultValue": {
        "value": "'left'",
        "computed": false
      },
      "required": false
    },
    "defaultMargin": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};
if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["Paragraph/index.js"] = {
    name: "Paragraph",
    docgenInfo: Paragraph.__docgenInfo,
    path: "Paragraph/index.js"
  };
}